import React from 'react';
import FeedBackAudio from './FeedBackReport/Audio';
import FeedBackImage from './FeedBackReport/Image';
import FeedBackText from './FeedBackReport/Text';
import FeedBackVideo from './FeedBackReport/Video';
import FeedBackFile from './FeedBackReport/Document';
import FeedBackLocation from './FeedBackReport/Location'
import FeedBackContact from './FeedBackReport/Contact'

const FeedBackReport = {
  text: FeedBackText,
  auto_text:FeedBackText,
  image: FeedBackFile,
  video: FeedBackFile,
  audio: FeedBackFile,
  file: FeedBackFile,
  contact:FeedBackContact,
  location:FeedBackLocation
};

const createComponent = ( chatType ) => FeedBackReport [ chatType ] || {};

const CreateTemplate = (props) => {
  const { message_type } = props;
  const Component = createComponent(message_type);
  if (!Component) return null;
  return <Component { ...props } />;
};

export default CreateTemplate;
